import { Action } from 'redux';

import { IPredictiveModelDetailInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { PredictiveModelSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { EnterPredictiveModelSubspace } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface EnterPredictiveModelSubspaceReduxAction extends Action {
  readonly predictiveModelDetailInfo: IPredictiveModelDetailInfo;
  readonly subspaceName: PredictiveModelSubspaceName;
}

export function enterPredictiveModelSubspace(
  predictiveModelDetailInfo: IPredictiveModelDetailInfo,
  subspaceName: PredictiveModelSubspaceName,
): EnterPredictiveModelSubspaceReduxAction {
  return {
    type: EnterPredictiveModelSubspace,
    predictiveModelDetailInfo,
    subspaceName,
  };
}

export const isEnterPredictiveModelSubspaceAction = isActionFactory<EnterPredictiveModelSubspaceReduxAction>(EnterPredictiveModelSubspace);
